"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
var _OrderItemRefundStatus = _interopRequireDefault(require("@/components/OrderItemRefundStatus.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DivisionRecordPanel',
  components: {
    OrderItemRefundStatus: _OrderItemRefundStatus.default
  },
  props: {
    parentHistory: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    orderNo: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      loaded: false,
      records: [],
      ledger: {
        allocations: [],
        refunds: []
      },
      ledgerError: false,
      historyError: false,
      requestId: 0,
      retryingId: null,
      queryingId: null,
      reconcileVisible: false,
      recordingReturn: false,
      recoveryVisible: false,
      recordingRecovery: false,
      recoveryForm: {
        refundOrderNo: '',
        divisionRefundDetailId: null,
        recoveryNo: '',
        amount: '',
        proofReference: ''
      },
      recoveryRules: {
        recoveryNo: [{
          required: true,
          message: '请填写线下追回流水号',
          trigger: 'blur'
        }],
        amount: [{
          required: true,
          pattern: /^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/,
          message: '请输入大于零且最多两位小数的金额',
          trigger: 'blur'
        }],
        proofReference: [{
          required: true,
          message: '请填写对账凭据',
          trigger: 'blur'
        }]
      },
      reconcileForm: {
        refundOrderNo: '',
        divisionRefundId: '',
        batchOrderId: '',
        receiverId: '',
        amount: '',
        channelState: 'SUCCESS',
        proofReference: ''
      },
      reconcileRules: {
        divisionRefundId: [{
          required: true,
          message: '请填计全付回退记录ID',
          trigger: 'blur'
        }],
        batchOrderId: [{
          required: true,
          message: '请填原分账批次',
          trigger: 'blur'
        }],
        receiverId: [{
          required: true,
          message: '请填接收方ID',
          trigger: 'blur'
        }],
        amount: [{
          required: true,
          pattern: /^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/,
          message: '请输入大于零且最多两位小数的金额',
          trigger: 'blur'
        }],
        channelState: [{
          required: true,
          message: '请选择渠道状态',
          trigger: 'change'
        }],
        proofReference: [{
          required: true,
          message: '请填写线下核验依据',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    retrying: function retrying() {
      return !!this.retryingId;
    },
    querying: function querying() {
      return !!this.queryingId;
    }
  },
  watch: {
    active: {
      immediate: true,
      handler: function handler(val) {
        if (val) this.ensureLoaded();
      }
    },
    orderNo: function orderNo() {
      this.requestId++;
      this.loading = false;
      this.loaded = false;
      this.records = [];
      this.ledger = {
        allocations: [],
        refunds: []
      };
      this.ledgerError = false;
      this.historyError = false;
      this.retryingId = null;
      this.queryingId = null;
      this.reconcileVisible = false;
      this.recoveryVisible = false;
      if (this.active) this.ensureLoaded();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.requestId++;
  },
  methods: {
    ensureLoaded: function ensureLoaded() {
      if (this.loaded || this.loading || !this.orderNo) return;
      this.loadData();
    },
    loadData: function loadData() {
      var _this = this;
      var requestId = ++this.requestId;
      var orderNo = this.orderNo;
      var parentHistory = this.parentHistory;
      var isCurrent = function isCurrent() {
        return requestId === _this.requestId && orderNo === _this.orderNo && parentHistory === _this.parentHistory;
      };
      this.loading = true;
      this.ledgerError = false;
      this.historyError = false;
      var ledgerRequest = parentHistory ? Promise.resolve() : (0, _order.getOrderDivisionItemLedgerApi)(this.orderNo).then(function (ledger) {
        if (!isCurrent()) return;
        _this.ledger = ledger || {
          allocations: [],
          refunds: []
        };
      }).catch(function () {
        if (!isCurrent()) return;
        _this.ledger = {
          allocations: [],
          refunds: []
        };
        _this.ledgerError = true;
      });
      return (parentHistory ? (0, _order.getParentOrderDivisionHistoryApi)(this.orderNo) : (0, _order.getOrderDivisionRecordsApi)(this.orderNo)).then(function (records) {
        if (!isCurrent()) return [];
        var list = (records || []).filter(function (record) {
          return _this.isOwnRecord(record);
        });
        if (!list.length) {
          _this.records = [];
          return [];
        }
        return Promise.all(list.map(function (record) {
          return Array.isArray(record.details) ? Promise.resolve(record) : parentHistory ? Promise.reject(new Error('原支付批次缺少明细')) : (0, _order.getOrderDivisionDetailsApi)(record.divisionOrderId).then(function (details) {
            return _objectSpread(_objectSpread({}, record), {}, {
              details: details || []
            });
          });
        })).then(function (recordsWithDetails) {
          if (!isCurrent()) return [];
          _this.records = recordsWithDetails;
          return recordsWithDetails;
        });
      }).then(function () {
        return ledgerRequest;
      }).then(function () {
        if (!isCurrent()) return;
        _this.loaded = true;
      }).catch(function () {
        if (!isCurrent()) return;
        _this.records = [];
        _this.historyError = parentHistory;
      }).finally(function () {
        if (!isCurrent()) return;
        _this.loading = false;
      });
    },
    isOwnRecord: function isOwnRecord(record) {
      return !!record && (!this.parentHistory || record.orderNo === this.orderNo) && (record.scopeOrderNo || record.orderNo) === this.orderNo;
    },
    recordScopeText: function recordScopeText(record) {
      if (this.parentHistory) return "\u539F\u652F\u4ED8\u6279\u6B21\u5386\u53F2\u8BB0\u5F55\uFF1A".concat(this.orderNo);
      return this.isOwnRecord(record) ? "\u672C\u8BA2\u5355\u5206\u8D26\u8BB0\u5F55\uFF1A".concat(this.orderNo) : "\u6240\u5C5E\u652F\u4ED8\u5355\u5386\u53F2\u8BB0\u5F55\uFF1A".concat(record.orderNo || '归属待核对');
    },
    recordStatusText: function recordStatusText(record) {
      if (this.isCompanyCollection(record)) return '公司代收（未发起直分）';
      return record.localPlan === true ? record.status === 'FAIL' ? '本地准备未完成（未提交渠道）' : '本地计划（尚未执行）' : record.queryError ? '渠道状态待核验' : record.bizScene === 'PAY_SUCCESS' && record.status === 'INIT' ? '渠道结果待确认' : this.statusText(record.status);
    },
    isCompanyCollection: function isCompanyCollection(record) {
      // 主单预检也会写执行时间；是否直分以明细的渠道证据为准。
      return !!record && String(record.providerCode).toLowerCase() === 'jeequan' && String(record.requestNo).endsWith(':SUPPLIER') && record.status === 'FAIL' && !record.queryError && Array.isArray(record.details) && record.details.length > 0 && record.details.every(function (detail) {
        return detail.status === 'FAIL' && detail.companyCollection === true;
      });
    },
    recordAmount: function recordAmount(record) {
      return this.isCompanyCollection(record) ? record.details.reduce(function (sum, detail) {
        return sum + Number(detail.amount || 0);
      }, 0) : record.amount;
    },
    receiptTaskTitle: function receiptTaskTitle(status) {
      return {
        PENDING: '收货分账待处理',
        RUNNING: '收货分账任务处理中',
        RETRY: '收货分账等待重试',
        SUCCESS: '收货分账任务已处理，请查看渠道结果',
        CANCELLED: '已退款，收货分账已终止',
        MANUAL: '收货分账需要核对'
      }[status] || '收货分账任务状态待核对';
    },
    receiptTaskReason: function receiptTaskReason(reason) {
      return {
        WAIT_WECHAT_RELEASE: '等待微信交易完成条件',
        WX_ORDER_QUERY_FAILED: '微信订单查询失败，任务将自动重试',
        WX_MERCHANT_ID_MISMATCH: '微信支付商户身份不匹配',
        WX_PAYMENT_IDENTITY_MISMATCH: '微信交易号、支付商户单号或付款人不匹配',
        WX_PAYMENT_AMOUNT_MISMATCH: '微信原支付金额与商城支付单不一致',
        ORDER_FULLY_REFUNDED: '订单已全额退款，不再发起新的收货分账',
        WAIT_REFUND_EFFECT: '等待退款处理完成'
      }[reason] || '';
    },
    canRetryDivision: function canRetryDivision(record) {
      return !this.parentHistory && !this.readonly && this.isOwnRecord(record) && !this.isCompanyCollection(record) && !!record.retryable;
    },
    hasDivisionAmount: function hasDivisionAmount(record) {
      return !this.parentHistory && record && Number(record.amount) > 0;
    },
    allocationsFor: function allocationsFor(record) {
      return (this.ledger.allocations || []).filter(function (item) {
        return item.divisionOrderId === record.divisionOrderId;
      });
    },
    divisionGroupText: function divisionGroupText(record) {
      if (!record || !record.requestNo) return '接收方';
      if (record.requestNo.endsWith(':SUPPLIER')) return '供货方';
      if (record.requestNo.endsWith(':USER')) return '用户权益';
      return '接收方';
    },
    allocationBasisText: function allocationBasisText(basis) {
      var labels = {
        UNIT: '商品结算单元',
        USER_SNAPSHOT: '分账时商品快照',
        COST_RECONCILED: '成本价与分账流水核对',
        UNATTRIBUTABLE: '缺少可核对的商品证据'
      };
      return labels[basis] || '-';
    },
    refundStatusText: function refundStatusText(status) {
      var labels = {
        0: '待审核',
        1: '已拒绝',
        2: '退款中',
        3: '已退款',
        4: '用户退货',
        5: '商家待收货',
        6: '已撤销'
      };
      return labels[status] || '-';
    },
    isManualExactRefund: function isManualExactRefund(refund) {
      return refund && refund.refundPolicy === 'JQF_MANUAL_EXACT_V1';
    },
    reconciliationText: function reconciliationText(status) {
      return {
        PENDING_OFFLINE_RECONCILIATION: '待线下对账',
        CHANNEL_INCOMPLETE: '渠道记录未完成',
        CASH_PROCESSING: '顾客退款处理中',
        EXPECTED_PENDING: '商城应退分冻结中',
        CASH_FAILED: '顾客退款失败',
        CASH_FAILED_RETURNED: '顾客退款失败、退分已回款待处理',
        RETURN_PENDING: '待发起退分',
        RETURN_PROCESSING: '渠道处理中',
        PLATFORM_ADVANCED: '平台垫付待追回',
        PLATFORM_ADVANCE_RECOVERED: '平台垫付已追回',
        MATCHED: '已对齐',
        DIFFERENT: '金额有差异',
        NOT_APPLICABLE: '原分账未生效'
      }[status] || '待核验';
    },
    reliefSyncText: function reliefSyncText(status, expectedStatus) {
      if (status === 'NOT_REQUIRED_NO_ORIGINAL') return '无原化债，无需冲正';
      if (status === 'NOT_REQUIRED') return expectedStatus === 'NO_ORIGINAL_EFFECT' ? '原分账未发生，无需冲正' : '无应冲正金额';
      return {
        SUCCESS: '已同步',
        MISSING: '任务缺失',
        WAIT_FUNDS: '等待退款',
        WAIT_ORIGINAL: '等待原收入',
        RETRY: '待重试',
        MANUAL: '待人工核对',
        CANCELLED: '已取消'
      }[status] || '处理中';
    },
    reconciliationTagType: function reconciliationTagType(status) {
      return {
        MATCHED: 'success',
        PLATFORM_ADVANCE_RECOVERED: 'success',
        DIFFERENT: 'danger',
        PLATFORM_ADVANCED: 'danger',
        CASH_FAILED: 'danger',
        CASH_FAILED_RETURNED: 'danger',
        CHANNEL_INCOMPLETE: 'warning',
        NOT_APPLICABLE: 'info'
      }[status] || 'warning';
    },
    receiverRoleText: function receiverRoleText(role) {
      return {
        SUPPLIER: '供应商',
        RELIEF: '化债接收方'
      }[role] || '接收方';
    },
    channelReturnText: function channelReturnText(state) {
      return {
        SUCCESS: '成功',
        FAILED: '失败',
        PROCESSING: '处理中'
      }[state] || '-';
    },
    cashRefundConfirmed: function cashRefundConfirmed(refund) {
      return refund.status === 3 && (!this.isManualExactRefund(refund) || String(refund.cashChannelStatus) === '2' || refund.cashAmount != null && Number(refund.cashAmount) === 0);
    },
    cashChannelText: function cashChannelText(status) {
      return {
        PREPARED: '排队待提交',
        UNKNOWN: '状态未确认，正在查询',
        0: '已受理',
        1: '处理中',
        2: '成功',
        3: '失败',
        4: '已关闭'
      }[status] || '待查询';
    },
    channelReturnTagType: function channelReturnTagType(state) {
      return {
        SUCCESS: 'success',
        FAILED: 'danger',
        PROCESSING: 'warning'
      }[state] || 'info';
    },
    openReconcile: function openReconcile(refund) {
      var _this2 = this;
      if (this.parentHistory || this.readonly) return;
      this.reconcileForm = {
        refundOrderNo: refund.refundOrderNo,
        divisionRefundId: '',
        batchOrderId: '',
        receiverId: '',
        amount: '',
        channelState: 'SUCCESS',
        proofReference: ''
      };
      this.reconcileVisible = true;
      this.$nextTick(function () {
        return _this2.$refs.reconcileForm && _this2.$refs.reconcileForm.clearValidate();
      });
    },
    saveReconcile: function saveReconcile() {
      var _this3 = this;
      if (this.parentHistory || this.readonly || this.recordingReturn) return;
      this.$refs.reconcileForm.validate(function (valid) {
        if (!valid || Number(_this3.reconcileForm.amount) <= 0) return;
        var orderNo = _this3.orderNo;
        _this3.recordingReturn = true;
        (0, _order.recordChannelReturnApi)(_this3.reconcileForm).then(function () {
          if (orderNo !== _this3.orderNo) return;
          _this3.reconcileVisible = false;
          _this3.$message.success('线下核验记录已保存');
          _this3.loaded = false;
          return _this3.loadData();
        }).catch(function () {
          return _this3.$message.error('保存失败，请核对记录身份和原分账金额');
        }).finally(function () {
          _this3.recordingReturn = false;
        });
      });
    },
    recoveryRemaining: function recoveryRemaining(refund, row) {
      if (!row || !row.divisionRefundDetailId) return 0;
      var recovered = (refund.advanceRecoveries || []).filter(function (item) {
        return item.divisionRefundDetailId === row.divisionRefundDetailId;
      }).reduce(function (sum, item) {
        return sum + Number(item.amount || 0);
      }, 0);
      return Math.max(0, Number(row.requestedAmount || 0) - recovered);
    },
    openRecovery: function openRecovery(refund, row) {
      var _this4 = this;
      if (this.parentHistory || this.readonly) return;
      this.recoveryForm = {
        refundOrderNo: refund.refundOrderNo,
        divisionRefundDetailId: row.divisionRefundDetailId,
        recoveryNo: '',
        amount: this.recoveryRemaining(refund, row).toFixed(2),
        proofReference: ''
      };
      this.recoveryVisible = true;
      this.$nextTick(function () {
        return _this4.$refs.recoveryForm && _this4.$refs.recoveryForm.clearValidate();
      });
    },
    saveRecovery: function saveRecovery() {
      var _this5 = this;
      if (this.parentHistory || this.readonly || this.recordingRecovery) return;
      this.$refs.recoveryForm.validate(function (valid) {
        if (!valid || Number(_this5.recoveryForm.amount) <= 0) return;
        var orderNo = _this5.orderNo;
        _this5.recordingRecovery = true;
        (0, _order.recordAdvanceRecoveryApi)(_this5.recoveryForm).then(function () {
          if (orderNo !== _this5.orderNo) return;
          _this5.recoveryVisible = false;
          _this5.$message.success('线下追回记录已保存');
          _this5.loaded = false;
          return _this5.loadData();
        }).catch(function () {
          return _this5.$message.error('保存失败，请核对渠道失败状态和可追回余额');
        }).finally(function () {
          _this5.recordingRecovery = false;
        });
      });
    },
    moneyOrDash: function moneyOrDash(value) {
      return value == null ? '-' : "\uFFE5".concat(this.formatAmount(value));
    },
    differenceText: function differenceText(value) {
      var amount = Number(value);
      return "".concat(amount < 0 ? '-' : '+', "\uFFE5").concat(Math.abs(amount).toFixed(2));
    },
    canQueryDivision: function canQueryDivision(record) {
      if (this.parentHistory || this.readonly) return false;
      if (!record || this.isCompanyCollection(record) || record.localPlan === true || record.status === 'INIT') return false;
      return record.queryable;
    },
    handleRetry: function handleRetry(record) {
      var _this6 = this;
      if (this.parentHistory || this.readonly) return;
      if (!record || !record.divisionOrderId || this.retrying || !this.records.includes(record)) return;
      var orderNo = this.orderNo;
      this.$confirm('确认重新发起分账？', '提示', {
        type: 'warning'
      }).then(function () {
        if (_this6.parentHistory || orderNo !== _this6.orderNo || !_this6.records.includes(record)) throw new Error('订单已切换');
        _this6.retryingId = record.divisionOrderId;
        return (0, _order.retryOrderDivisionApi)(record.divisionOrderId);
      }).then(function (res) {
        if (orderNo !== _this6.orderNo) return;
        var message = res && res.message ? res.message : '已重新发起分账';
        _this6.$message.success(message);
        return _this6.refreshAfterRetry(record, res);
      }).catch(function () {}).finally(function () {
        if (orderNo === _this6.orderNo) _this6.retryingId = null;
      });
    },
    refreshAfterRetry: function refreshAfterRetry(record, result) {
      var _this7 = this;
      if (this.parentHistory) return;
      var orderNo = this.orderNo;
      var shouldQuery = result && result.success && result.status === 'PROCESSING';
      var syncResult = shouldQuery ? (0, _order.queryOrderDivisionApi)(record.divisionOrderId).catch(function () {
        return null;
      }) : Promise.resolve();
      return syncResult.then(function () {
        if (orderNo !== _this7.orderNo) return;
        _this7.loaded = false;
        return _this7.loadData();
      });
    },
    handleQueryResult: function handleQueryResult(record) {
      var _this8 = this;
      if (this.parentHistory || this.readonly) return;
      if (!record || !record.divisionOrderId || this.querying || !this.records.includes(record)) return;
      var orderNo = this.orderNo;
      this.queryingId = record.divisionOrderId;
      (0, _order.queryOrderDivisionApi)(record.divisionOrderId).then(function (res) {
        if (orderNo !== _this8.orderNo) return;
        var message = res && res.message ? res.message : '查询完成';
        _this8.$message.success(message);
        _this8.loaded = false;
        return _this8.loadData();
      }).catch(function () {}).finally(function () {
        if (orderNo === _this8.orderNo) _this8.queryingId = null;
      });
    },
    statusText: function statusText(status) {
      var textMap = {
        INIT: '初始化',
        PROCESSING: '处理中',
        SUCCESS: '成功',
        PART_SUCCESS: '部分成功',
        FAIL: '失败',
        CLOSED: '关闭'
      };
      return textMap[status] || status || '-';
    },
    statusTagType: function statusTagType(status) {
      var typeMap = {
        SUCCESS: 'success',
        PROCESSING: 'warning',
        PART_SUCCESS: 'warning',
        FAIL: 'danger',
        CLOSED: 'info'
      };
      return typeMap[status] || 'info';
    },
    formatAmount: function formatAmount(value) {
      var amount = Number(value || 0);
      return amount.toFixed(2);
    }
  }
};